import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { OutstandingBalanceProvider } from './contexts/OutstandingBalanceContext';
import { FeatureProvider } from './contexts/FeatureContext';
import { OrganizationBrandingProvider } from './contexts/OrganizationBrandingContext';
import { ChatProvider } from './contexts/ChatContext';
import appConfig from './config/appConfig';
import { startPushNavigation } from './utils/pushNavigation';

// Listen for notification taps before React and auth load, so a tap on a resuming/cold-starting app isn't lost.
startPushNavigation();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={appConfig.auth0Domain}
      clientId={appConfig.auth0ClientId}
      authorizationParams={{
        redirect_uri: appConfig.auth0RedirectUri,
        audience: appConfig.auth0Audience,
        // offline_access requests a refresh token so the SDK can silently
        // renew the access token without an iframe (which fails when third-
        // party cookies are blocked).
        scope: 'openid profile email offline_access',
        // Enable organization selection prompt
        prompt: 'select_account',
        // Allow user to select organization
        organization: undefined
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      // Fall back to iframe silent auth if the refresh token call fails.
      useRefreshTokensFallback={true}
      // Trust the cached session for up to 7 days before forcing a re-check.
      sessionCheckExpiryDays={7}
    >
      <AuthProvider>
        <OrganizationBrandingProvider>
          <FeatureProvider>
            <PermissionsProvider>
              <OutstandingBalanceProvider>
                <ChatProvider>
                  <App />
                </ChatProvider>
              </OutstandingBalanceProvider>
            </PermissionsProvider>
          </FeatureProvider>
        </OrganizationBrandingProvider>
      </AuthProvider>
    </Auth0Provider>
  </React.StrictMode>
);
